import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./index.css";
import { Flip, ToastContainer } from "react-toastify";
import { createRoot } from "react-dom/client";
import ReminderNotification from "./ReminderNotification";
import ChatReminderNotification from "./ChatReminderNotification";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Router>
    <ReminderNotification />
    <ChatReminderNotification />
    <App />
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      transition={Flip}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
  </Router>
);
